import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { BREAKPOINTS } from '@/styles/themes/default';

import { LiveButton, slideToLeft, slideToRight, delayedAnimation } from './shared';

const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
  min-height: 350px;

  @media (min-width: ${BREAKPOINTS.Tablet.min}px) {
    min-height: 400px;
  }
`;

const BaseImage = styled.img`
  position: absolute;
  z-index: 1;
  left: 100%;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  height: auto;
  max-width: 100%;
  padding: 0 20px;
  top: 20px;

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    padding: 0;
    max-width: 490px;
  }
`;

const liveButtonInitialStyles = css`
  position: absolute;
  z-index: 2;
  left: 100%;
  top: 0;
`;

const Comment1 = styled.img`
  position: absolute;
  z-index: 3;
  right: 100%;
  max-width: 260px;
  top: 140px;

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    top: 210px;
  }
`;

const Comment2 = styled.img`
  position: absolute;
  z-index: 3;
  right: 100%;
  max-width: 260px;
  margin-right: 20px;
  top: 215px;

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    top: 285px;
  }
`;

export const MainStage = () => {
  return (
    <Wrapper>
      <BaseImage css={slideToLeft} src="/images/landing/eventExample/main-stage-video.jpg" alt="main stage example" />
      <LiveButton css={[slideToLeft, liveButtonInitialStyles, delayedAnimation(0.7)]} label="live" />
      <Comment1
        css={[slideToRight, delayedAnimation(1.1)]}
        src="/images/landing/eventExample/main-stage-comment-1.png"
        alt="main stage comment example"
      />
      <Comment2
        css={[slideToRight, delayedAnimation(1.5)]}
        src="/images/landing/eventExample/main-stage-comment-2.png"
        alt="main stage comment example"
      />
    </Wrapper>
  );
};
